// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { EntitlmentDocument } from '@shared/utils/Entitlment/EntitlmentDocument';
export class EntitlementDocumentGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.DOCUMENT_GROUP, null, pfixFieldSet);
    }
    static CreateDocument(documentId, name, content) {
        const gr = new EntitlementDocumentGroup();
        gr.setId(documentId);
        gr.setName(name);
        gr.setContent(content);
        return gr;
    }
    GetDoucument() {
        return new EntitlmentDocument(this.getId(), this.getName(), this.getContent());
    }
    getId() {
        return this.GetValue(FieldsFactory.FIELD_DOCUMENT_ID);
    }
    setId(value) {
        this.SetField(FieldsFactory.FIELD_DOCUMENT_ID, value);
    }
    getName() {
        return this.GetValue(FieldsFactory.FIELD_NAME);
    }
    setName(value) {
        this.SetField(FieldsFactory.FIELD_NAME, value);
    }
    getContent() {
        return this.GetValue(FieldsFactory.FIELD_DOCUMENT_CONTENT);
    }
    setContent(value) {
        this.SetField(FieldsFactory.FIELD_DOCUMENT_CONTENT, value);
    }
}
